import React from 'react';
import { connect } from 'react-redux';
import * as Ui from '../Ui';
import SearchBar from './SearchBar';
import TopicsList from './TopicsList';
import ResultsList from './ResultsList';
import Answer from './Answer';
import FAQButton from './FAQButton';
import Icon from '../common/components/Icon';
import { SecondaryButton } from '../Ui';
import { sendCallbackRequest } from '../webAPI/faqService';
import { doShowToast } from '../reducers/app/toast';

const FAQ = ({
	showFaq,
	topics,
	terms,
	results,
	question,
	answer,
	onHelpButtonClick,
	onSearchChange,
	onQuestionClick,
	onPreviousClick,
	dispatch
}) => (
	<div style={{ display: 'flex' }} className="faq">
		{showFaq && (
			<div className="faq__content">
				<header className="faq__header">
					<div className="faq__title">
						<img
							className="faq__avatar"
							src={require('../../assets/avatar.png')}
						/>
						<h1>Besoin de notre aide ?</h1>
						<div className="faq__close" onClick={onHelpButtonClick}>
							<Icon icon="reduce" size="small" />
						</div>
					</div>
				</header>

				{/*
				<Ui.ButtonsBlock>
					<Ui.SecondaryButton iconName="call-back">Être rappelé</Ui.SecondaryButton>
					<Ui.PrimaryButton iconName="chat">Chatter</Ui.PrimaryButton>
				</Ui.ButtonsBlock>
				*/}

				<div className="faq__search-bar-container">
					<SearchBar value={terms} onChange={onSearchChange} />
				</div>

				<div className="faq__body">
					{showAnswer(answer) ? (
						<Answer
							question={question}
							answer={answer}
							onClick={onPreviousClick}
						/>
					) : terms ? (
						<TopicsList
							topics={results}
							onClick={onQuestionClick}
						/>
					) : (
						<TopicsList topics={topics} onClick={onQuestionClick} />
					)}
				</div>
				<div className="faq__triangle" />
			</div>
		)}
		<FAQButton onClick={onHelpButtonClick} />
	</div>
);

function showAnswer(answer) {
	return answer.length > 0;
}

export default connect()(FAQ);



// WEBPACK FOOTER //
// ./src/js/faq/FAQ.js